import React, { useEffect } from 'react';
import { css } from 'emotion';
import { RetinaPicture } from 'components/RetinaPicture';
import {
  TextLink,
  ButtonPrimary,
  screenSmMax,
} from '@spotify-internal/encore-web';
import { Modal } from '@spotify-internal/anchor-ds';
import { paths } from 'client/shared/Paths';
import { events } from './events';

const SpotifyOnlyDistributionModal = ({
  onClickClose,
  onOptInClick,
  isLoading,
  isError,
}: {
  onClickClose: () => void;
  onOptInClick: () => void;
  isLoading: boolean;
  isError: boolean;
}) => {
  // analytics
  useEffect(() => {
    events.distributeToSpotifyModalScreenView();
  }, []);

  return (
    <Modal
      isShowing
      isShowingCloseButton
      aria-labelledby="spotify-only-distro-title"
      onClose={() => {
        events.distributeToSpotifyExitButtonClicked();
        onClickClose();
      }}
      size="small"
    >
      <Modal.Title id="spotify-only-distro-title">
        Ready to publish?
      </Modal.Title>
      <Modal.Subtitle>
        This will make your podcast available on Anchor and Spotify. You can
        distribute your podcast to more platforms in the next step.
      </Modal.Subtitle>
      <Modal.Body>
        <RetinaPicture
          className={css`
            width: 328px;
            height: 360px;

            @media (max-width: ${screenSmMax}) {
              width: 228px;
              height: 260px;
            }
          `}
          imagePath="/distribution/ic_distribution_preview"
          alt="Minimalized display of Spotify's mobile user interface"
          fallbackExtension="png"
        />
      </Modal.Body>
      {isError && (
        <Modal.Error>
          Hm, something went wrong. Please try again or if the issue persists,
          reach out to us at{' '}
          <TextLink
            href={paths.getHelpPage('home')}
            target="_blank"
            rel="noopener noreferrer"
          >
            {paths.getHelpPage('home')}
          </TextLink>
          .
        </Modal.Error>
      )}
      <Modal.Footer>
        <ButtonPrimary
          onClick={() => {
            events.distributeToSpotifyPublishButtonClicked();
            onOptInClick();
          }}
          disabled={isLoading}
        >
          {isError ? 'Retry' : 'Publish'}
        </ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
};

export { SpotifyOnlyDistributionModal };
